import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import {
  addRemoveBillingGroups,
  getMisc,
  getSpecificBIllingGroupGroups,
} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import AddToBillingGroup from "../../../views/popups/billinggroups/AddToBillingGroup";
import PopupLoader from "../../../views/popups/PopupLoader";
import { useTranslation } from "react-i18next";
import DeleteGroup from "../../../views/popups/users/DeleteGroup";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

function BillingGroups({ billingGInfo, isActive }) {
  const { t, i18n } = useTranslation();
  const [billing, setBilling] = useState([]);
  const [freeGroups, setfreeGroups] = useState([]);
  const navigate = useNavigate();
  const [addGroup, setAddGroup] = useState(false);
  const toggleGroup = () => setAddGroup(!addGroup);
  const [updateGroups, setUpdateGroups] = useState([]);
  const [updateGroupsExecuted, setUpdateGroupsExecuted] = useState(false);
  const [isdeleteGroup, setIsDeleteGroup] = useState(false);
  const dtogglePopup = () => setIsDeleteGroup(!isdeleteGroup);
  const [deleteGroupFlag, setdeleteGroupFlag] = useState(false);
  const [rerender, setrerender] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [deleteMessage, setdeleteMessage] = useState("");


  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [billingDetails, setBillingDetails] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)

  const handleDelete = (event, infoObj) => {
    event.preventDefault();
    setUpdateGroups([infoObj]);
    addGroups("remove_bgrps", 1, [infoObj]);
  };

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function getSpecificBGG() {
    try {
      const response = await getSpecificBIllingGroupGroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        billingGInfo.billing_group_id
      );
      const rawData = await response.json();
      console.log(
        "Specific billing group groups :::::::::::::::" +
          JSON.stringify(rawData)
      );
      const bill = (rawData?.billing_groups ?? []).map((bil) => ({
        ...bil,
        group_name: bil.group_name.replace("[S] ", "").replace("[I] ", ""),
      }));
      setBilling(bill);
    } catch (e) {
      console.log(`Unable to load the sepcific billing group groups:${e}`);
    }
  }
  useEffect(() => {
    if (isActive || rerender) {
      getSpecificBGG();
      setrerender(false);
    }
  }, [isActive, rerender]);

  useEffect(() => {
    async function getBillingInfoMisc(e) {
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        {
          misc: ["billing_settings_info"],
          billing_group_id: billingGInfo.billing_group_id,
        }
      );
      console.log(response);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      console.log(
        "billing info misc details ::::::::: " + JSON.stringify(tdata)
      );
      const bill = (
        tdata?.misc?.billing_settings_info?.available_billing_groups ?? []
      ).map((bil) => ({
        ...bil,
        group_name: bil.group_name.replace("[S] ", "").replace("[I] ", ""),
      }));
      setfreeGroups(bill);
    }

    if (billingGInfo.billing_group_id) {
      getBillingInfoMisc();
    }
  }, [billingGInfo,isActive]);

  useEffect(()=>{ 
  let processdrows = [];
  billing.map((grp) => {
    processdrows.push({
      groupInfo: grp,
      name: grp.group_name,
      type: grp?.group_type ?? "",
      remove: (
        <div className="d-flex align-items-center ms-2">
          <div
            className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
            onClick={(e) => handleDelete(e, grp)}
          >
            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
          </div>
        </div>
      ),
    });
  });
  setBillingDetails(processdrows);
  setFilteredRows(processdrows)
  setDataLoaded(true)
},[billing])


  const actionDataGroup = {
    columns: [
      { label: "Name", field: "name" },
      { label: "Type", field: "type" },
      { label: "Remove", field: "remove" },
    ],
    rows: billingDetails,
  };

  async function addGroups(fieldName, isconfirm, groupsInfo) {
    let addidList = [];
    if (updateGroups.length === 0 && isconfirm && isconfirm === 1) {
      addidList = new Set(groupsInfo.map((item) => item.billing_group_id + ""));
    } else {
      addidList = new Set(updateGroups.map((item) => item.billing_group_id + ""));
    }
    const addtitleList = new Set(updateGroups.map((item) => item.group_name));
    let update = {
      reqid: 132,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      bgrp_id: billingGInfo.billing_group_id,

      [fieldName]: Array.from(addidList),
    };

    // if (fieldName === "remove_bgrps" && isconfirm) {
    //   update.confirm = isconfirm === 1 ? false : true;
    // }

    console.log(JSON.stringify(update));
    let saverep = await addRemoveBillingGroups(update, isconfirm);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "remove_bgrps" && isconfirm === 1) {
        console.log(
          "saverepeMsg :::::::::::::: " + JSON.stringify(saverepeMsg)
        );
        setdeleteMessage(saverepeMsg?.message ?? "");
        dtogglePopup();
      } else {
        setrerender(true);
        setSuccessMessage(saverepeMsg.message);
      }
    } else {
      // if (fieldName === "removed_groups") {
      //   const modifynum = selectedGroups.filter((item1) =>
      //     updateGroups.some((item2) => item2.code !== item1.code)
      //   );
      //   setSelectedGroups([...modifynum, ...updateGroups]);
      // }
      if (saverepeMsg.message?.errors) {
        //   saverepeMsg.message.errors.forEach((err) => {
        //     if (err.param_name === "logined_user") {
        //       setErrorMessage(err.message);
        //     }
        //     const fieldElement = document.querySelector(
        //       `input[name="${err.param_name}"]`
        //     );
        //     if (fieldElement) {
        //       fieldElement.focus();
        //       fieldElement.scrollIntoView({ behavior: "smooth" });
        //     }
        //   });
      } else {
        setrerender(true);
      }
    }
  }

  useEffect(() => {
    if (updateGroups.length > 0 && updateGroupsExecuted) {
      addGroups("add_bgrps");
      setUpdateGroupsExecuted(false);
    }
  }, [updateGroups, updateGroupsExecuted]);

  useEffect(() => {
    if (updateGroups.length > 0 && deleteGroupFlag) {
      addGroups("remove_bgrps", 2);
      setdeleteGroupFlag(false);
    }
  }, [updateGroups, deleteGroupFlag]);


const handleManualSearch = (searchValue) => {
  setsearchValue(searchValue); 

  const filteredUsers = customSearch(billingDetails, searchValue, UIConstant.BILLING_DETAILS);

  setFilteredRows(filteredUsers);
};

  return (
    <>
      <div>
        <div className="actionbar">
          <MDBBtn
            onClick={(e) => {
              e.preventDefault();
              toggleGroup();
            }}
          >
            Add Group
          </MDBBtn>
        </div>
        <div className='mb-2 mt-2 position-relative w-auto'>
          <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
          <MDBIcon fas icon="search" className='MDBDatatable-Search' />
        </div>
        <div className="locationUsersDatatble">
          <MDBDatatable
             key={searchValue}
            entries={50}
            data={{
              ...actionDataGroup,
              rows: filteredRows, 
            }}
            className="actioncolumn"
            sortField="Billing Groups"
          />
        </div>
      </div>
      {addGroup && (
        <PopupLoader
          // size="lg"
          // className="modal-lg"
          title={t("Add Billing Group")}
          content={
            <AddToBillingGroup
              uniqueId={billingGInfo.billing_group_id}
              selectedGroups={billing}
              setUpdateGroups={setUpdateGroups}
              setUpdateGroupsExecuted={setUpdateGroupsExecuted}
              sourceGroups={freeGroups}
              onClose={toggleGroup}
            />
          }
          onShow={setAddGroup}
          onClose={toggleGroup}
        />
      )}

      {isdeleteGroup && (
        <PopupLoader
          title={"Remove Group"}
          content={
            <DeleteGroup
              onClose={dtogglePopup}
              setdeleteGroupFlag={setdeleteGroupFlag}
              deleteMessage = {deleteMessage}
            />
          }
          onShow={setIsDeleteGroup}
          onClose={dtogglePopup}
        />
      )}
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}
    </>
  );
}

export default BillingGroups;
